var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 22 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 10a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 6c4.422 0 8-3.578 8-8a8 8 0 00-8-8C3.586 0 0 3.586 0 8a8 8 0 008 8zM9 3.5v5c0 .273-.227.5-.5.5h-1a.504.504 0 01-.5-.5v-5c0-.273.227-.5.5-.5h1c.273 0 .5.227.5.5z"
  })));
};
export default SvgInfoIcon;